// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-form-input{border-radius:9999px;height:2rem;--tw-bg-opacity:1;background-color:#f4f4f2;font-weight:500;padding:.5rem 1rem}@supports (color:rgb(0 0 0/0)){.c-form-input{background-color:rgb(244 244 242/var(--tw-bg-opacity))}}@media (min-width:640px){.c-form-input{padding-left:1.5rem;padding-right:1.5rem}}@media (min-width:768px){.c-form-input{font-size:.875rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
